module.exports = __webpack_public_path__ + "img/email-empty.b32b56fa.png";